(function () {
  function enhance(root) {
    var cont = root.querySelector(".lb-addon-cont");
    var head = cont && cont.querySelector(".lb-addon-head");
    if (!cont || !head || cont.getAttribute("data-zawo-collapse") === "1") return;

    cont.setAttribute("data-zawo-collapse", "1");
    head.setAttribute("role", "button");
    head.setAttribute("tabindex", "0");
    head.setAttribute("aria-expanded", "false");

    function toggle() {
      var open = cont.classList.toggle("is-open");
      head.classList.toggle("is-open", open);
      head.setAttribute("aria-expanded", open ? "true" : "false");
    }

    head.addEventListener("click", toggle);
    head.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggle();
      }
    });
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;

    var host = node.closest ? node.closest("lb-addon") : null;
    if (node.tagName && node.tagName.toLowerCase() === "lb-addon") host = node;
    if (host) enhance(host);

    if (node.querySelectorAll) {
      node.querySelectorAll("lb-addon").forEach(enhance);
    }
  }

  function start() {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener("DOMContentLoaded", start);
  }
})();
